/* src/app/components/popover-help/popover-help.component.scss */
.item-hover {
  cursor: pointer;
}
/*# sourceMappingURL=popover-help.component.css.map */
